"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleShopifyUrlPopover = exports.closeModal = exports.openModal = exports.ShopConnectionActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _fluxActions = require("flux-actions");

var ShopConnectionActionTypes = (0, _namespacedKeyMirror.default)({
  OPEN_MODAL: null,
  CLOSE_MODAL: null,
  TOGGLE_SHOPIFY_URL_POPOVER: null
}, 'shop-connection');
exports.ShopConnectionActionTypes = ShopConnectionActionTypes;
var openModal = (0, _fluxActions.createAction)(ShopConnectionActionTypes.OPEN_MODAL);
exports.openModal = openModal;
var closeModal = (0, _fluxActions.createAction)(ShopConnectionActionTypes.CLOSE_MODAL);
exports.closeModal = closeModal;
var toggleShopifyUrlPopover = (0, _fluxActions.createAction)(ShopConnectionActionTypes.TOGGLE_SHOPIFY_URL_POPOVER);
exports.toggleShopifyUrlPopover = toggleShopifyUrlPopover;